<template>
    <div class="sidebar-module">
        <div v-if="(!noDashboard || (index === 0 || !modules[index-1].no_dashboard || (modules[index-1].no_dashboard && modules[index-1].lessons.length > 1))) && modules_count >= 1" class="tw-flex tw-items-center tw-bg-gray-100 tw-p-4 tw-rounded-lg tw-font-bold tw-text-gray-700 tw-mb-1 tw-mt-2 tw-cursor-pointer" @click="expand">
            <i v-if="!noDashboard && module.available" class="far fa-circle tw-text-gray-300 tw-text-2xl tw-mr-2 tw-rounded-full" :class="{'finished': moduleFinished}"></i>
            <i v-else-if="!module.available" class="far fa-lock tw-text-gray-300 tw-text-2xl tw-mr-2 mimic-title">
                <span v-if="unlocksAt !== null">{{ $t('membership.unlocks_at') }} {{ unlocksAt }}</span>
            </i>
            <div class="tw-flex tw-items-center tw-justify-between tw-flex-1">
                <h3 class="tw-leading-normal tw-flex tw-flex-wrap">
                    <span v-if="course.numbered">{{ $t('membership.module') }} {{ chapters_structure[index].chapter }}</span>
                    <template v-if="!noDashboard">
                        <span class="tw-pl-2 tw-ml-1 tw-border-l-2 tw-border-gray-200 tw-truncate tw-flex-1" v-text="module.name"></span>
                    </template>
                </h3>
                <i class="fa tw-text-gray-300 tw-pl-2" :class="expanded ? 'fa-angle-down' : 'fa-angle-up'"></i>
            </div>
        </div>
        <SmoothReflow>
            <template v-if="expanded">
                <template v-if="!noDashboard">
					<SidebarLesson v-for="(content, lesson_index) in module.lessons"
								   :key="content.id"
								   :index="index"
								   :lesson_index="lesson_index"
								   :content="content"
								   :module="module"
								   :course="course"
								   :no_dashboard="noDashboard"
								   :chapters_structure="chapters_structure"
					>
					</SidebarLesson>
                </template>
				<SidebarLesson v-else-if="display_content_without_module"
							   :index="index"
							   :content="module.lessons[0]"
							   :module="module"
							   :course="course"
							   :no_dashboard="noDashboard"
							   :chapters_structure="chapters_structure"
				>
				</SidebarLesson>
            </template>
        </SmoothReflow>
    </div>
</template>

<script>
    import Global from '../../mixins/Global.js'
    import {mapState} from 'vuex';
	import Link from "../Link";
	import SidebarLesson from "./SidebarLesson";

    export default {
        name: 'sidebar_module',
		components: {
			SidebarLesson,
			Link,
		},
		mixins: [Global],

        props: ['module', 'index', 'modules', 'course', 'modules_count', 'chapters_structure'],

        data() {
            return {
                expanded: true,
            }
        },

        computed: {
            ...mapState(['display_content_without_module']),

            moduleFinished() {
				let progress = 100;

				if (this.module.lessons.length > 0) {
					const percentagePerLesson = 100 / this.module.lessons.length;

					for (let i = 0; i < this.module.lessons.length; i += 1) {
						if (!this.module.lessons[i].seen) {
							progress -= percentagePerLesson;
						}
					}
				}

                return progress === 100;
            },

			// only count modules as no_dashboard if they only have 1 lesson (this wasnt always the case due to old legacy working of this feature)
			noDashboard() {
				return this.module.no_dashboard && this.module.lessons.length <= 1;
			},

            unlocksAt() {
                if (this.module.available_from === null) {
                    return null;
                }

                return moment(this.module.available_from).format("DD-MM-YYYY HH:mm");
            },
        },

        methods: {
            expand() {
                this.expanded = !this.expanded;

                if(this.noDashboard) {
                    this.$store.commit('toggleContentWithoutModuleVisibility');
                }
            },
        },

        mounted() {
			//scroll to the active lesson in the sidebar
            this.$nextTick(() => {
                if($('.active-lesson')[0]) {
                    let pos = $('.active-lesson')[0].offsetTop;
                    let sidebar_pos = this.$parent.$refs.sidebarWrapper.offsetTop;
                    let sidebar_height = this.$parent.$refs.sidebarWrapper.offsetHeight;

                    if((sidebar_height - sidebar_pos) < pos) {
                        this.$parent.$refs.sidebar.scrollTop = pos - 5;
                    }
                }
            });
        }
    }
</script>

<style lang="scss">
    .sidebar-module {
        .mimic-title {
            span {
                left: 0;
                transform: none;
            }
        }

		.finished {
			@apply tw-relative tw-bg-gray-300;

			&:after {
				@apply tw-absolute tw-top-0 tw-left-0 tw-text-gray-600 tw-font-semibold tw-text-xs;
				top: 6px;
				left: 5px;
				content: "\f00c";
				font-family: 'Font Awesome 5 Pro';
			}
		}

        &:last-of-type {
            margin-bottom: 15px;
        }
    }
</style>